export default __webpack_public_path__ + "static/media/Comp_2.8c56e100.gif";